/*
A collection of default settings/values for changable options.
Editing highly supported.
Changing e.g. Defaults, colours, edges, states
*/

//Defaults
let isDecimal = false; // true = decimal, false = percent
let isEdgeDeleteButtonVisible = true; // true = foreignObject, false = path
let edgeDeleteButtonSize = 40; // Size of the edge delete button
let defaultNodeName = "New Node";

//Colours
let primaryAccent = "#007bb9";
// let defaultEdgeConnectColour = "#555";
let defaultEdgeOutputConnectColour = "Green";
let defaultEdgeOutputConnectColourHover = primaryAccent;
let defaultEdgeInputConnectColour = "Red";
let defaultEdgeInputConnectColourHover = primaryAccent;

//Edges
let edgeType = "default"

//States
let useSetStates = true; // true = use setStates, false = don't use setStates
let nodeNameOnly = false; // true = only show node name, false = show node name and states
let showProbabilities = true; // true = show probabilities, false = don't show probabilities
let probabilitiesBlank = false; // true = probabilities blank, false = probabilities not blank
let significantFigures = 4; // Number of significant figures points to show
let keepTrailing = true; // true = trailing zeros, false = no trailing zeros
let deleteMode = false; // true = delete mode, false = normal mode
let showBars = true; // true = show bars, false = don't show bars
let barsFillState = true; // true = bars fill state, false = bars come up as extra column

//Wizard
let isModal = true; // true = modal, false = drawer

// Set decimal
export function setDecimal(dec) {
    isDecimal = dec;
}
  
// Get decimal
export function getDecimal() {
    return isDecimal;
}

// Set edge delete button visibility
export function setEdgeDeleteButtonVisibility(vis) {
    isEdgeDeleteButtonVisible = vis;
}

// Get edge delete button visibility
export function getEdgeDeleteButtonVisibility() {
    return isEdgeDeleteButtonVisible;
}

// Set edge delete button size
export function setEdgeDeleteButtonSize(size) {
    edgeDeleteButtonSize = size;
}

// Get edge delete button size
export function getEdgeDeleteButtonSize() {
    return edgeDeleteButtonSize;
}

// Set default node name
export function setDefaultNodeName(name) {
    defaultNodeName = name;
}

// Get default node name
export function getDefaultNodeName() {
    return defaultNodeName;
}

// Set default edge output connect colour
export function setDefaultEdgeOutputConnectColour(colour) {
    defaultEdgeOutputConnectColour = colour;
}

// Get default edge output connect colour
export function getDefaultEdgeOutputConnectColour() {
    return defaultEdgeOutputConnectColour;
}

// Set default edge output connect colour hover
export function setDefaultEdgeOutputConnectColourHover(colour) {
    defaultEdgeOutputConnectColourHover = colour;
}

// Get default edge output connect colour hover
export function getDefaultEdgeOutputConnectColourHover() {
    return defaultEdgeOutputConnectColourHover;
}

// Set default edge input connect colour
export function setDefaultEdgeInputConnectColour(colour) {
    defaultEdgeInputConnectColour = colour;
}

// Get default edge input connect colour
export function getDefaultEdgeInputConnectColour() {
    return defaultEdgeInputConnectColour;
}

// Set default edge input connect colour hover
export function setDefaultEdgeInputConnectColourHover(colour) {
    defaultEdgeInputConnectColourHover = colour;
}

// Get default edge input connect colour hover
export function getDefaultEdgeInputConnectColourHover() {
    return defaultEdgeInputConnectColourHover;
}

// Set use set states
export function setUseSetStates(use) {
    useSetStates = use;
}

// Get use set states
export function getUseSetStates() {
    return useSetStates;
}

// Set node name only
export function setNodeNamesOnly(nameOnly) {
    nodeNameOnly = nameOnly;
}

// Get node name only
export function getNodeNamesOnly() {
    return nodeNameOnly;
}

// Set show probabilities
export function setShowProbabilities(show) {
    showProbabilities = show;
}

// Get show probabilities
export function getShowProbabilities() {
    return showProbabilities;
}

// Set probabilities blank
export function setProbabilitiesBlank(blank) {
    probabilitiesBlank = blank;
}

// Get probabilities blank
export function getProbabilitiesBlank() {
    return probabilitiesBlank;
}

// Set number of significant figures
export function setSignificantFigures(points) {
    significantFigures = points;
}

// Get number of significant figures
export function getSignificantFigures() {
    return significantFigures;
}

// Set trailing zeros
export function setKeepTrailing(trailing) {
    keepTrailing = trailing;
}

// Get trailing zeros
export function getKeepTrailing() {
    return keepTrailing;
}

// Set delete mode
export function setDeleteMode(mode) {
    deleteMode = mode;
}

// Get delete mode
export function getDeleteMode() {
    return deleteMode;
}

// Set primary accent
export function setPrimaryAccent(colour) {
    primaryAccent = colour;
}

// Get primary accent
export function getPrimaryAccent() {
    return primaryAccent;
}

// Set modal
export function setModal(modal) {
    isModal = modal;
}

// Get modal
export function getModal() {
    return isModal;
}

// Set show bars
export function setShowBars(bars) {
    showBars = bars;
}

// Get show bars
export function getShowBars() {
    return showBars;
}

// Set bars fill state
export function setBarsFillState(fill) {
    barsFillState = fill;
}

// Get bars fill state
export function getBarsFillState() {
    return barsFillState;
}

export function setEdgeType(type) {
    edgeType = type;
}

export function getEdgeType() {
    return edgeType;
}


//Function returns original values for settings (to faciliate cancel button)
export function getSettingsMenu() {
    return {
        isDecimal: isDecimal,
        isModal: isModal,
        significantFigures: significantFigures,
        edgeType: edgeType,
        probabilitiesBlank: probabilitiesBlank,
    }
}